import axios from '@/utils/request'
//pc端获取登录页公司名
export const getLoginCompanyName = (id, data, header, options) => {
  return axios.get(
    '/api/saas/login/companyName?domain=' + id,
    data,
    header,
    options
  )
}
//用户登录
export const userLogin = (data, header, options) => {
  return axios.post(
    '/api/saas/user/loginByMobileVerifyCode',
    data,
    header,
    options
  )
}
//企业微信登录
export const workWechatLogin = (data, header, options) => {
  return axios.post('/api/saas/epWechat/login', data, header, options)
}
//企业微信登录获取企业微信跳转地址
export const workWechatAuthorize = (data, header, options) => {
  return axios.get('/api/saas/epWechat/authorize', data, header, options)
}
//发送验证码
export const sendLoginMessage = (data, header, options) => {
  return axios.post('/api/saas/captcha/sendsms', data, header, options)
}
//用户退出
export const userLogout = (data, header, options) => {
  return axios.get('/api/saas/user/logout', data, header, options)
}
//公共接口
export const getDefaultDept = (data, header, options) => {
  return axios.get('/api/saas/common/defaultDept', data, header, options)
}
//公司列表
export const getAllCompany = (data, header, options) => {
  return axios.get('/api/saas/companyList', data, header, options)
}
//公司基本信息
export const getCompanyDetail = (data, header, options) => {

  return axios.get('/api/saas/companyInfo', data, header, options)
}
//成员列表
export const getMemberList = (data, header, options) => {
  return axios.post('/api/saas/companyMemberList', data, header, options)
}
//课程列表
export const getCourseList = (data, header, options) => {
  return axios.post('/api/saas/companyStudyCourseList', data, header, options)
}
//录播课程列表
export const getRecordCourseList = (data, header, options) => {
  return axios.post('/api/saas/recordCourseList', data, header, options)
}
//学习报告-获取查看报告里学习统计信息
export const getMemberDetailStatistics = (dept, id, data, header, options) => {
  return axios.get(
    '/api/saas/memberReport/statistics/' + dept + '/' + id,
    data,
    header,
    options
  )
}
//课程情况-查看报告里查看课程统计
export const getCourseDetailStatistics = (id, data, header, options) => {
  return axios.get(
    '/api/saas/courseReport/statistics/' + id,
    data,
    header,
    options
  )
}
//课程学习-录播课程目录（旧）
export const oldGetCourseDetailCatalogue = (id, data, header, options) => {
  return axios.get(
    '/api/saas/recordCourse/contents/' + id,
    data,
    header,
    options
  )
}
//课程学习-录播课程介绍（旧）
export const oldGetCourseDetailIntroduction = (id, data, header, options) => {
  return axios.get(
    '/api/saas/recordCourse/introduction/' + id,
    data,
    header,
    options
  )
}
//课程学习-录播课程目录（新）
export const getCourseDetailCatalogue = (id, data, header, options) => {
  return axios.get(
    '/api/saas/recordCourse/newContents/' + id,
    data,
    header,
    options
  )
}
//课程学习-录播课程介绍（新）
export const getCourseDetailIntroduction = (id, data, header, options) => {
  return axios.get(
    '/api/saas/recordCourse/newIntroduction/' + id,
    data,
    header,
    options
  )
}
//团队管理-组织架构
export const getOrganizationalStructure = (data, header, options) => {
  return axios.get('/api/saas/deptOrg', data, header, options)
}
//团队管理-部门查看成员列表
export const getDepartmentMember = (data, header, options) => {
  return axios.post('/api/saas/deptMemberList', data, header, options)
}
//团队管理-获取部门信息
export const getDepartmentInformation = (id, data, header, options) => {
  return axios.get('/api/saas/deptInfo/' + id, data, header, options)
}
//团队管理-成员添加
export const addDepartmentMember = (data, header, options) => {
  return axios.post('/api/saas/batchAddMember/', data, header, options)
}
//团队管理-成员批量导入
export const importMember = (deptId, data, header, options) => {
  return axios.post('/api/saas/importMember/' + deptId, data, header, options)
}
//团队管理-成员编辑
export const editDepartmentMember = (data, header, options) => {
  return axios.post('/api/saas/updateMember', data, header, options)
}
//团队管理-获取成员信息 编辑成员时使用
export const editDepartmentMemberInfo = (dept, id, data, header, options) => {
  return axios.get(
    '/api/saas/memberInfo/' + dept + '/' + id,
    data,
    header,
    options
  )
}
//团队管理-删除成员
export const deleteDepartmentMember = (id, data, header, options) => {
  return axios.post('/api/saas/deleteMember/' + id, data, header, options)
}
//团队管理-成员移除团队
export const removeDepartmentMember = (id, data, header, options) => {
  return axios.post('/api/saas/memberRemoveDept/' + id, data, header, options)
}
//团队管理-添加子级部门
export const addDepartmentBranch = (data, header, options) => {
  return axios.post('/api/saas/addChildDept', data, header, options)
}
//团队管理-【部门编辑时子公司/部门主管成员列表】或【添加子级时子公司/部门主管成员列表】
export const departmentBranchMemberList = (data, header, options) => {
  return axios.post('/api/saas/deptChooseMemberList', data, header, options)
}
//团队管理-编辑部门
export const editDepartmentBranch = (data, header, options) => {
  return axios.post('/api/saas/updateDept', data, header, options)
}
//团队管理-获取部门管理员信息 编辑部门时使用 返回部门管理员姓名 部门名称
export const editBranchInfo = (id, data, header, options) => {
  return axios.get('/api/saas/deptAdminInfo/' + id, data, header, options)
}
//团队管理-删除部门
export const deleteDepartmentBranch = (data, header, options) => {
  return axios.post('/api/saas/deleteDept', data, header, options)
}
//学习报告-课程情况中某个课程对应的成员列表
export const getCourseDetailMemberList = (data, header, options) => {
  return axios.post(
    '/api/saas/memberReport/studyDetailList',
    data,
    header,
    options
  )
}
//学习报告-课程情况中某个课程对应的成员列表
export const getCourseRecordMemberList = (data, header, options) => {
  return axios.post(
    '/api/saas/courseStudyRecordMemberList',
    data,
    header,
    options
  )
}
//课程学习-编辑公司Logo
export const editCompanyLogo = (data, header, options) => {
  return axios.post('/api/saas/updateCompanyLogo', data, header, options)
}
//课程学习-切换公司
export const transformCpmpany = (id, data, header, options) => {
  return axios.post(
    '/api/saas/switchCompany?deptId=' + id,
    data,
    header,
    options
  )
}

//课程学习-更新课程学习进度
export const oldUpdateStudyProgress = (data, header, options) => {
  var newHeadr = { ...header, DeviceType: "pc" }
  return axios.post(
    '/api/saas/recordCourse/updateStudyProgress',
    data,
    newHeadr,
    options
  )
}
//课程学习-更新课程学习进度
export const updateStudyProgress = (data, header, options) => {
  var newHeadr = { ...header, DeviceType: "pc" }
  return axios.post(
    '/api/saas/recordCourse/newUpdateStudyProgress',
    data,
    newHeadr,
    options
  )
}

//课程学习-获取录播课程最近一次学习的课节编号 播放的帧的位置
export const getVideoProgress = (id, data, header, options) => {
  return axios.get(
    '/api/saas/recordCourse/studyPosition/' + id,
    data,
    header,
    options
  )
}
//判断访问域名是否存在
export const justifyAdmin = (data, header, options) => {
  return axios.get('/api/saas/verifyDomain', data, header, options)
}

//团队管理-下载导入成员模板
export const downloadTemplete = (data, header, options) => {
  return axios.get('/api/saas/memberTemplate', data, header, options)
}
//团队管理-批量删除成员
export const emptyBatchMember = (data, header, options) => {
  return axios.post('/api/saas/batchDeleteMember', data, header, options)
}
//管理学习计划-计划列表
export const studyPlanList = (data, header, options) => {
  return axios.post('/api/saas/mplan/planList', data, header, options)
}
//管理学习计划-计划类型列表
export const studyPlanModeList = (data, header, options) => {
  return axios.get('/api/saas/mplan/planTypeList', data, header, options)
}
//管理学习计划-创建或编辑计划类型
export const updatePlanMode = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/addOrUpdatePlanType',
    data,
    header,
    options
  )
}
//管理学习计划-删除计划类型
export const deletePlanMode = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/deletePlanType/' + id,
    data,
    header,
    options
  )
}
//管理学习计划-删除学习计划
export const deletePlanRow = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/deletePlanBase/' + id,
    data,
    header,
    options
  )
}
//获取学习计划-基本信息
export const planBasicInfo = (planId, data, header, options) => {
  return axios.get(`/api/saas/mplan/planBase/${planId}`, data, header, options)
}
//学习计划基本信息-创建或编辑基本计划信息
export const updateBasicInfo = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/addOrUpdatePlanBase',
    data,
    header,
    options
  )
}
//选择课程阶段-计划中可选课程列表
export const ableSelectedCourse = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/selectablePlanCourseList',
    data,
    header,
    options
  )
}
//选择课程阶段-计划中已选课程列表
export const hasSelectedCourse = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/selectedPlanCourseList',
    data,
    header,
    options
  )
}
//选择课程阶段-获取学习计划时长、可选课程总数和分钟数信息
export const ableSelectCourseInfo = (id, data, header, options) => {
  return axios.get(
    '/api/saas/mplan/planCourseBaseInfo/' + id,
    data,
    header,
    options
  )
}
//选择课程阶段-获取已选课程信息
export const selectedCourseInfo = (id, data, header, options) => {
  return axios.get(
    '/api/saas/mplan/selectedPlanCourseBaseInfo/' + id,
    data,
    header,
    options
  )
}
//选择课程-单个或批量添加课程
export const addPlanCourse = (data, header, options) => {
  return axios.post('/api/saas/mplan/addPlanCourse', data, header, options)
}
//选择课程-单个或批量移除课程
export const removePlanCourse = (data, header, options) => {
  return axios.post('/api/saas/mplan/removePlanCourse', data, header, options)
}
//选择课程-全选添加课程
export const addTotalPlanCourse = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/selectAllAddPlanCourse/' + id,
    data,
    header,
    options
  )
}
//选择课程-全选移除课程
export const removeTotalPlanCourse = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/selectAllRemovePlanCourse/' + id,
    data,
    header,
    options
  )
}
//阶段测试-阶段测试列表
export const partTestList = (id, data, header, options) => {
  return axios.get(
    '/api/saas/mplan/planStageExamList/' + id,
    data,
    header,
    options
  )
}
//阶段测试-阶段测试列表
export const partTestListTwo = (id, data, header, options) => {
  return axios.get(
    '/api/saas/mplan/planStageExamList2/' + id,
    data,
    header,
    options
  )
}
//阶段测试-保存页面显示的阶段测试列表
export const saveStageExam = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/savePlanStageExam/' + id,
    data,
    header,
    options
  )
}
//综合测试-保存页面显示的综合测试列表
export const savePlanExam = (id, data, header, options) => {
  return axios.post('/api/saas/mplan/savePlanExam/' + id, data, header, options)
}
//用户学习计划-我的计划列表
export const myPlanList = (data, header, options) => {
  return axios.post('/api/saas/uplan/myPlanList', data, header, options)
}
//管理学习计划-其他管理员下级计划列表
export const otherPlanList = (data, header, options) => {
  return axios.post('/api/saas/mplan/planOthersList', data, header, options)
}
//用户学习计划-我的计划数量
export const myPlanSortNum = (data, header, options) => {
  return axios.get('/api/saas/uplan/myPlanCount', data, header, options)
}
//阶段测试-下载题目模板
export const planTemplete = (data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planStageExamTemplate`,
    data,
    header,
    options
  )
}
//阶段测试-创建或编辑阶段测试
export const createPlanList = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/addOrUpdatetPlanStageExam',
    data,
    header,
    options
  )
}
//阶段测试-导入阶段测试
export const importPlanList = (params, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/batchImportPlanStageExamQuestion?' + params,
    data,
    header,
    options
  )
}
//阶段测试-删除阶段测试
export const removePartPlan = (params, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/deletePlanStageExam/' + params,
    data,
    header,
    options
  )
}
//阶段测试-获取阶段测试信息
export const partTestDetail = (id, data, header, options) => {
  return axios.get(`/api/saas/mplan/planStageExam/${id}`, data, header, options)
}
//阶段测试-题目列表
export const partTestQuestionList = (id, type, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planStageExam/questionList2/${id}/${type}`,
    data,
    header,
    options
  )
}
export const partTestQuestionListByEdit = (id, type, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planStageExam/questionList/${id}/${type}`,
    data,
    header,
    options
  )
}
//阶段测试-获取单个题目信息
export const partTestQuestionDetail = (id, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planStageExamQuestion/${id}`,
    data,
    header,
    options
  )
}
//阶段测试-删除单个题目
export const deleteTestQuestion = (id, data, header, options) => {
  return axios.post(
    `/api/saas/mplan/deletePlanStageExamQuestion/${id}`,
    data,
    header,
    options
  )
}
//综合测试-综合测试列表
export const totalPlanList = (id, data, header, options) => {
  return axios.get(`/api/saas/mplan/planExamList/${id}`, data, header, options)
}
//综合测试-综合测试列表2
export const totalPlanListTwo = (id, data, header, options) => {
  return axios.get(`/api/saas/mplan/planExamList2/${id}`, data, header, options)
}
//综合测试-创建或编辑综合测试
export const creatPlanExam = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/addOrUpdatetPlanExam',
    data,
    header,
    options
  )
}
//阶段测试-导入综合测试
export const importPlanExam = (params, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/batchImportPlanExamQuestion?' + params,
    data,
    header,
    options
  )
}
//综合测试-删除综合测试
export const removePlanExam = (params, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/deletePlanExam/' + params,
    data,
    header,
    options
  )
}
//综合测试-获取综合测试信息
export const planExamDetail = (id, data, header, options) => {
  return axios.get(`/api/saas/mplan/planExam/${id}`, data, header, options)
}
//综合测试-获取单个题目信息
export const planExamQuestionDetail = (id, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planExamQuestion/${id}`,
    data,
    header,
    options
  )
}
//综合测试-删除单个题目
export const deleteTotalQuestion = (id, data, header, options) => {
  return axios.post(
    `/api/saas/mplan/deletePlanExamQuestion/${id}`,
    data,
    header,
    options
  )
}
//综合测试-查询题目列表(编辑)
export const planExamQuestionListByEdit = (id, mode, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planExam/questionList/${id}/${mode}`,
    data,
    header,
    options
  )
}
//综合测试-查询题目列表(添加)
export const planExamQuestionListByAdd = (id, mode, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planExam/questionList2/${id}/${mode}`,
    data,
    header,
    options
  )
}
//添加学习人员-部门组织架构
export const planMemberOrgList = (id, data, header, options) => {
  return axios.get(`/api/saas/mplan/planDeptOrg/${id}`, data, header, options)
}
//添加学习人员-成员列表
export const planMemberList = (id, data, header, options) => {
  return axios.post(
    '/api/saas/mplan/planDeptMemberList/' + id,
    data,
    header,
    options
  )
}
//添加学习人员-选中成员
export const planMemberChecked = (planId, deptId, data, header, options) => {
  return axios.get(
    `/api/saas/mplan/planSelectedUserIdList/${planId}/${deptId}`,
    data,
    header,
    options
  )
}
//添加学习人员-全部成员
export const planMemberTotalList = (data, header, options) => {
  return axios.post(
    `/api/saas/mplan/planCompanyMemberList`,
    data,
    header,
    options
  )
}
//添加学习人员-批量添加学习成员
export const createPlanMember = (data, header, options) => {
  return axios.post(`/api/saas/mplan/batchAddPlanUser`, data, header, options)
}
//用户学习计划-课程列表(带学习进度)
export const myPlanCourseList = (data, header, options) => {
  return axios.post(`/api/saas/uplan/myStudyCourseList`, data, header, options)
}
//  用户学习计划-更新所有我的计划状态 (待开始 进行中 已完成 到期未完成)
export const updateMyPlanStatus = (data, header, options) => {
  return axios.post(`/api/saas/uplan/updateMyPlanStatus`, data, header, options)
}
//用户学习计划-阶段测试列表
export const myPartPlanList = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/myStageExamList/${id}`,
    data,
    header,
    options
  )
}
//用户学习计划-综合测试列表
export const myTotalPlanList = (id, data, header, options) => {
  return axios.get(`/api/saas/uplan/myExamList/${id}`, data, header, options)
}
//获取阶段测试基本信息
export const myPartTestInfo = (id, data, header, options) => {
  return axios.get(`/api/saas/uplan/userStageExam/${id}`, data, header, options)
}
//生成阶段测试题目
export const partTestQuestionPaper = (data, header, options) => {
  return axios.post(`/api/saas/uplan/generateStageExam`, data, header, options)
}
// 阶段测试-已完成状态查看用户最近一次试卷报告
export const userLastStageExamReport = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/userLastStageExamReport/${id}`,
    data,
    header,
    options
  )
}
//提交单个阶段测试题目作答信息
export const submitQuestion = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/submitStageExamUserQuestion`,
    data,
    header,
    options
  )
}
//提交阶段测试试卷并返回做题结果
export const submitExam = (data, header, options) => {
  return axios.post(`/api/saas/uplan/submitStageExam`, data, header, options)
}
//计划课程完成情况统计
export const planFinishState = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/course/statistics/${id}`,
    data,
    header,
    options
  )
}
//更新阶段测试考试时间
export const updateExamTime = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/updateStageExamTime`,
    data,
    header,
    options
  )
}
//查看阶段测试 全部解析/查看错题
export const examAnalysis = (data, header, options) => {
  return axios.post(`/api/saas/uplan/stageExamAnalysis`, data, header, options)
}
//获取综合测试基本信息
export const myTotalTestInfo = (id, data, header, options) => {
  return axios.get(`/api/saas/uplan/userExam/${id}`, data, header, options)
}
//生成综合测试题目或获取上次退出没有答完的试卷
export const totalTestQuestionList = (data, header, options) => {
  return axios.post(`/api/saas/uplan/generateExam`, data, header, options)
}
// 综合测试-已完成状态查看用户最近一次试卷报告
export const userLastExamReport = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/userLastExamReport/${id}`,
    data,
    header,
    options
  )
}
//提交单个综合测试题目作答信息
export const examTotalTestQuestion = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/submitExamUserQuestion`,
    data,
    header,
    options
  )
}
//更新综合测试考试时间
export const updateTotalTestExamTime = (data, header, options) => {
  return axios.post(`/api/saas/uplan/updateExamTime`, data, header, options)
}
//提交综合测试试卷并返回做题结果
export const submitTotalTest = (data, header, options) => {
  return axios.post(`/api/saas/uplan/submitExam`, data, header, options)
}
//查看综合测试 全部解析/查看错题
export const totalExamAnalysis = (data, header, options) => {
  return axios.post(`/api/saas/uplan/examAnalysis`, data, header, options)
}
//管理计划中统计报表-统计报表基本信息
export const planStatisticsBasicInfo = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/planReport/baseStatistics/${id}`,
    data,
    header,
    options
  )
}
//管理计划中统计报表-统计报表统计数据
export const planStatisticsEcharts = (id, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/planReport/dataStatistics/${id}`,
    data,
    header,
    options
  )
}
//管理计划中统计报表-计划测评数据基本信息 阶段测试/综合测试通用
export const planTestStatisticsData = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/planReport/examBaseStatistics`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-阶段测试课程详情要求列表 有分页
export const userStageExamStudyCourseList = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/userStageExamStudyCourseList`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-综合测试课程详情/个人报告下面卡片显示计划课程列表(带学习进度) 有分页
export const userStudyCourseList = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/userStudyCourseList`,
    data,
    header,
    options
  )
}
//管理计划中统计报表-计划测评数据考试人员统计列表
export const examStatisticsList = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/planReport/examStatisticsList`,
    data,
    header,
    options
  )
}
//管理计划中统计报表-统计数据详情页显示某个计划所有学习人员
export const planStudyUserList = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/planReport/planStudyUserList`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-用户已加入的计划列表(用于计划切换)
export const userPlanList = (deptId, userId, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/userPlanList/${deptId}/${userId}`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-计划课程完成情况统计
export const userPlanFinishState = (planId, userId, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/course/statistics/${planId}/${userId}`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-阶段测试统计列表
export const partPlanStatisticsList = (
  planId,
  userId,
  data,
  header,
  options
) => {
  return axios.get(
    `/api/saas/uplan/stageExam/statisticsList/${planId}/${userId}`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-综合测试统计列表
export const totalPlanStatisticsList = (
  planId,
  userId,
  data,
  header,
  options
) => {
  return axios.get(
    `/api/saas/uplan/exam/statisticsList/${planId}/${userId}`,
    data,
    header,
    options
  )
}
//管理学习计划-其他下级管理员列表
export const childAdminUserList = (data, header, options) => {
  return axios.get(`/api/saas/mplan/childAdminUserList`, data, header, options)
}
//学习报告中某个成员学习计划统计-用户阶段测试考试记录列表
export const stageExamRecordList = (examId, userId, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/stageExamRecordList/${examId}/${userId}`,
    data,
    header,
    options
  )
}
//学习报告中某个成员学习计划统计-用户综合测试考试记录列表
export const examRecordList = (examId, userId, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/examRecordList/${examId}/${userId}`,
    data,
    header,
    options
  )
}
//用户学习计划-查看我已完成的学习计划的证书
export const myPlanCertificate = (planId, data, header, options) => {
  return axios.get(
    `/api/saas/uplan/myPlanCertificate/${planId}`,
    data,
    header,
    options
  )
}
//用户学习计划-阶段测试课程要求列表
export const myStageExamStudyCourseList = (data, header, options) => {
  return axios.post(
    `/api/saas/uplan/myStageExamStudyCourseList`,
    data,
    header,
    options
  )
}
//我的权益录播-直播课程列表
export const liveCourseList = (data, header, options) => {
  return axios.post(`/api/saas/liveCourseList`, data, header, options)
}
//我的权益录播-录播课程列表
export const recordCourseList = (data, header, options) => {
  return axios.post(`/api/saas/recordCourseList`, data, header, options)
}
//我的权益录播-录播课程分类列表
export const recordCourseCategoryList = (data, header, options) => {
  return axios.get(`/api/saas/recordCourseCategoryList`, data, header, options)
}
//我的权益录播-更新用户选择的课程二级分类
export const updateUserChooseCategory = (id, data, header, options) => {
  return axios.post(
    `/api/saas/updateUserChooseCategory/${id}`,
    data,
    header,
    options
  )
}
//我的权益录播-用户上次选择录播课程的三级分类名称列表 (三级分类的 对应前端页面全部后面的显示数据)
export const recordCourseUser3CategoryList = (data, header, options) => {
  return axios.get(
    `/api/saas/recordCourseUser3CategoryList`,
    data,
    header,
    options
  )
}
//我的权益直播-预约直播课前查询剩余次数
export const appointmentCourseTimes = (id, data, header, options) => {
  return axios.get(
    `/api/saas/appointmentCourseTimes/${id}`,
    data,
    header,
    options
  )
}
//我的权益直播-预约直播课
export const appointmentCourse = (id, data, header, options) => {
  return axios.post(`/api/saas/appointmentCourse/${id}`, data, header, options)
}
//我的权益直播-直播课程详情(回放或直播中)
export const liveCourseDetail = (id, data, header, options) => {
  return axios.get(`/api/saas/liveCourseDetail/${id}`, data, header, options)
}
//我的权益直播-直播课程详情(回放或直播中)
export const h5LiveCourseDetail = (id, data, header, options) => {
  return axios.get(`/api/saas/h5LiveCourseDetail/${id}`, data, header, options)
}
//我的权益直播-直播课程详情签到
export const liveCourseSignIn = (data, header, options) => {
  return axios.post(`/api/saas/liveCourse/signIn`, data, header, options)
}
//获取线上公开课详情【点预约接口调用】
export const onlineOpenCourseDetail = (id, data, header, options) => {
  return axios.get(
    `/api/saas/onlineOpenCourseDetail/${id}`,
    data,
    header,
    options
  )
}
//获取直播授权地址
export const getLiveAuthAddress = (id, data, header, options) => {
  return axios.get(
    `/api/saas/zsw/getLiveAuthAddress/${id}`,
    data,
    header,
    options
  )
}
//预约线上公开课
export const appointmentOnlineOpenCourse = (data, header, options) => {
  return axios.post(
    '/api/saas/appointmentOnlineOpenCourse',
    data,
    header,
    options
  )
}
// 课程学习-切换公司
export const switchCompanyChange = (data, header, options) => {
  return axios.post(
    `/api/saas/switchCompany?deptId=${data.deptId}&clientType=${data.clientType}`,
    data,
    header,
    options
  )
}
// 课程学习-录播课程授权(授予观看权限)
export const courseAuth = (recordId, data, header, options) => {
  return axios.post(
    `/api/saas/recordCourse/auth/${recordId}`,
    data,
    header,
    options
  )
}

//官网和企业中心-录播课程相关课程列表 pc和h5共用
export const recordRelatedCourseList = (data, header, options) => {
  return axios.post(
    '/api/saas/zsw/recordRelatedCourseList',
    data,
    header,
    options
  )
}
//课程组列表 无分页
export const courseGroupList = (data, header, options) => {
  return axios.get('/api/saas/courseGroupList', data, header, options)
}
//搜索学员（通过名字搜索）列表 无分页
export const studyMemberList = (data, header, options) => {
  return axios.get('/api/saas/studyMemberList', data, header, options)
}
//课程组-录播课程列表
export const studyRecordCourseList = (data, header, options) => {
  return axios.post('/api/saas/studyRecordCourseList', data, header, options)
}
//新建或编辑课程组
export const saveOrUpdateCourseGroup = (data, header, options) => {
  return axios.post('/api/saas/saveOrUpdateCourseGroup', data, header, options)
}
//删除课程组
export const deleteCourseGroup = (id, data, header, options) => {
  return axios.post('/api/saas/deleteCourseGroup/' + id, data, header, options)
}
//课程组详情
export const courseGroupDetail = (id, data, header, options) => {
  return axios.get('/api/saas/courseGroupDetail/' + id, data, header, options)
}
//问题答疑模块   获取提问页面 下拉框
export const getSelectOption = (header, options) => {
  return axios.get("/api/saas/qa/init", header, options);
};
//问题答疑模块   提交问题
export const submitQa = (header, options) => {
  return axios.post("/api/saas/qa/submit", header, options);
};
//问题答疑模块  类别
export const getnumber = (header, options) => {
  return axios.get("/api/saas/qa/number", header, options);
};


//问题答疑模块   列表
export const getlist = (header, options) => {
  return axios.post("/api/saas/qa/list", header, options);
};

//获取目录下练习题
export const getExerciseList = (data, header, options) => {
  return axios.post('/api/saas/record/exercise/list', data, header, options)
}
//获取目录下练习题详情
export const getPaperResult = (data, header, options) => {
  return axios.post(
    'api/saas/record/exercise/getPaperResult',
    data,
    header,
    options
  )
}

//填充答案并提交试卷
export const submitExerciseResult = (data, header, options) => {
  return axios.post(
    '/api/saas/record/exercise/fillAnswerExam',
    data,
    header,
    options
  )
}

//pc和h5企业中心-上报直播回放进度
export const liveupdateStudyProgress = (data, header, options) => {
  var newHeader = { ...header, DeviceType: "pc" }
  return axios.post(
    '/api/saas/live/updateStudyProgress',
    data,
    newHeader,
    options
  )
}

//新接口-获取用户当前域名对应企业部门信息
export const userCompanyInfo = (header, options) => {
  return axios.get("/api/hxt/userCompanyInfo", header, options);
};


//直播课程列表(通用个人或企业)-支持登录和未登录
export const hxtliveList = (data, header, options) => {
  return axios.post(
    '/api/hxt/liveList',
    data,
    header,
    options
  )
}

//我的录播课程分类
export const getCompanyCourseCategory = (data, header, options) => {
  return axios.get(`/api/hxt/getCompanyCourseCategory`, data, header, options)
}

//企业录播课程列表及我的录播课程列表
export const getCompanyCourseList = (data, header, options) => {
  return axios.post(
    '/api/hxt/getCompanyCourseList',
    data,
    header,
    options
  )
}

// 获取智答地址(内部调用)

export const getSmartQAUrl = (data, header, options) => {
  return axios.get(`/api/app/smart/getSmartQAUrl`, data, header, options);
}


//企业录播课程列表及我的录播课程列表
export const skipPlanCourse = (data, header, options) => {
  return axios.post(
    '/api/saas/mplan/skipPlanCourse',
    data,
    header,
    options
  )
}

//课程组选择人员 左侧组织架构树
export const groupDeptOrg = (id, data, header, options) => {
  return axios.get(`/api/saas/groupDeptOrg?courseGroupId=${id}`, data, header, options)
}

//左侧架构全选状态下企业所有用户列表(不带选中状态)

export const groupCompanyMemberList = (data, header, options) => {
  return axios.post(
    '/api/saas/groupCompanyMemberList',
    data,
    header,
    options
  )
}

//某个部门下用户列表（带选中状态-课程组已选用户的）

export const groupDeptMemberList = (data, header, options) => {
  return axios.post(
    '/api/saas/groupDeptMemberList',
    data,
    header,
    options
  )
}
// //获取录播课讲义显示状态
export const lecturesDownload = (data, header, options) => {
  return axios.get(`api/hxt/lecturesDownload`, data, header, options);
}

//专题计划列表（个人或企业）

export const getMySpecPlanList = (data, header, options) => {

  return axios.post('/api/hxt/getMySpecPlanList', data, header, options);
}

//专题计划详情（个人或企业）

export const getMySpecPlanDetail = (data, header, options) => {

  return axios.post('/api/hxt/getMySpecPlanDetail', data, header, options);
}

//获取企业米诺测评状态

export const examAuth = (data, header, options) => {
  return axios.get(`/api/hxt/examAuth`, data, header, options);
}


//管理测评列表（带分页）
export const deptExamList = (data, header, options) => {
  return axios.post('/api/hxt/deptExamList', data, header, options);
}

//我的测评列表（带分页）

export const myExamList = (data, header, options) => {
  return axios.post('/api/hxt/myExamList', data, header, options);
}

//测评详情
export const examDetail = (data, header, options) => {
  return axios.get(`/api/hxt/examDetail`, data, header, options);
}


//保存测评信息


export const updateExam = (data, header, options) => {
  return axios.post('/api/hxt/updateExam', data, header, options);
}

//统计
export const getEvaluationReport = (data, header, options) => {
  return axios.post('/api/hxt/paper/getEvaluationReport', data, header, options);
}


//检查机构是否拥有会员答疑权限

export const canQA = (data, header, options) => {
  return axios.get(`/api/hxt/canQA`, data, header, options);
}

//获取米诺测评显示状态（新接口）


export const examStatus = (data, header, options) => {
  return axios.get(`/api/hxt/examStatus`, data, header, options);
}

//专题按钮判断是否可以查看下载报告
export const checkSpecReport = (data, header, options) => {
  return axios.post('/api/hxt/checkSpecReport', data, header, options);
}
//专题报告详情
export const specReport = (data, header, options) => {
  return axios.get(`/api/hxt/specReport`, data, header, options);
}

//上报各端启动记录

export const userLogStart = (data, header, options) => {

  return axios.post('/api/hxt/userLogStart', data, header, options);
}

//预约报告
export const generate = (data, header, options) => {
  return axios.post('/api/hxt/report/study/generate', data, header, options);
}
//报告列表
export const studylist = (data, header, options) => {
  return axios.get(`/api/hxt/report/study/list`, data, header, options);
}
//重置报告
export const reGenerate = (data, header, options) => {
  return axios.post('/api/hxt/report/study/reGenerate', data, header, options);
}
//企业报告详情页数据
export const studyDetailReport = (data, header, options) => {
  return axios.get(`/api/hxt/report/study/detail`, data, header, options);
}

//获取报告总览月份字典
export const getDicts = (data, header, options) => {
  return axios.post('/api/hxt/getDicts', data, header, options);
}

//课程评价-提交评价

export const submitEvaluate = (data, header, options) => {

  return axios.post('/api/hxt/submitEvaluate', data, header, options);
}

//课程评价-获取是否评价
export const userEvaluate = (data, header, options) => {
  return axios.get(`/api/hxt/userEvaluate`, data, header, options);
}

//埋点-录播视频课播放上报播放量
export const logVideo = (data, header, options) => {
  return axios.post(`/api/hxt/logVideo`, data, header, options);
}